module.exports = __webpack_public_path__ + "media/photo/communications2-f52af3d9.jpg";